import React from 'react';
import styled from '@emotion/styled';
import Text from '@ff/ui/Text';
import Animate from './Animate';
import TitleCarousel from './TitleCarousel';
import type { Props as PropsSchema } from './props-schema';

export interface Props {
  topSubtitle?: string;
  title?: string;
  subtitle?: string;
  subtitleCarousel?: PropsSchema['slides'][0]['subtitleCarousel'];
  animate?: boolean;
}

export default function Heading(props: Props) {
  const { topSubtitle, title, subtitle, subtitleCarousel, animate } = props;

  return (
    <Container>
      <Animate
        animate={animate}
        duration={1000}
        keyframes={titleKeyframe}
      >
        {topSubtitle && <Subtitle>{topSubtitle}</Subtitle>}
        <Title>{title}</Title>
      </Animate>
      {subtitle &&
        <Animate
          animate={animate}
          duration={1000}
          animationDelay='500ms'
          // take the style values set by the first keyframe of the animation during the animation-delay period
          animationFillMode='backwards'
          keyframes={titleKeyframe}
        >
          <Subtitle>{subtitle}</Subtitle>
        </Animate>
      }
      {subtitleCarousel?.length > 0 && <TitleCarousel textList={subtitleCarousel.map(x => x.text)} />}
    </Container>
  );
}

// same obj for keyframe during render
const titleKeyframe = {
  from: {
    opacity: 0,
    transform: 'translateY(20px)'
  },
  to: {
    opacity: 1,
    transform: 'translateY(0px)'
  },
};

const Container = styled(Text)({
  textAlign: 'center'
});

const Title = styled(Text)(({ theme }) => ({
  fontWeight: theme.fontWeights.light,
  fontSize: '30px',
  color: 'rgba(224, 223, 231, 1)',
  lineHeight: '47.4px',
  letterSpacing: '0.006em',

  [theme.mediaQueries.md]: {
    fontSize: '40px'
  }
}));

const Subtitle = styled(Text)(({ theme }) => ({
  fontWeight: theme.fontWeights.light,
  fontSize: 18,
  lineHeight: '24px',
  margin: '8px',
  color: 'rgba(224, 223, 231, 1)',
  '& a': {
    color: 'rgba(224, 223, 231, 1) !important'
  },

  [theme.mediaQueries.md]: {
    fontSize: 20,
  }
}));
